type Props = {
    size: 'sm' | 'lg';
    type: 'primary' | 'secondary' | 'tertiary';
};

export function Spinner({ size, type }: Props) {
    const sizeClass = size === 'sm' ? 'spinner-sm' : 'spinner-lg';

    let typeClass = 'spinner-primary';
    switch (type) {
        case 'secondary':
            typeClass = 'spinner-secondary';
            break;
        case 'tertiary':
            typeClass = 'spinner-tertiary';
            break;
    }

    return (
        <svg
            version="1.1"
            id="L4"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 52 12"
            enableBackground="new 0 0 0 0"
            xmlSpace="preserve"
            className={`spinner ${typeClass} ${sizeClass}`}
        >
            <circle fill="currentColor" stroke="none" cx={6} cy={6} r={6}>
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.1"
                />
            </circle>
            <circle fill="currentColor" stroke="none" cx={26} cy={6} r={6}>
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.2"
                />
            </circle>
            <circle fill="currentColor" stroke="none" cx={46} cy={6} r={6}>
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.3"
                />
            </circle>
        </svg>
    );
}
